import PropTypes from 'prop-types';
import Story from './story';

 /**
  * @memberof module:react/propTypes
  * @typedef {Object} RunningOrder
  * @prop {string} id Running order id
  * @prop {string} name Running order name (AKA, Slug)
  * @prop {string} revision Revision of this running order
  * @prop {boolean} readyToAir True if the runnin gorder is ready to air
  * @prop {module:react/propTypes~Story[]} stories Stories contained in this running order
  */
export default PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  revision: PropTypes.string,
  readyToAir: PropTypes.boolean,
  stories: PropTypes.arrayOf(Story)
});



// WEBPACK FOOTER //
// ./app/propTypes/runningOrder.js